export default {
  apiKey: "AIzaSyDyJu1k-NNRmoK-eMq9l_hgr3cChgO-g_s",
  authDomain: "tagset2018.firebaseapp.com",
  databaseURL: "https://tagset2018.firebaseio.com",
  projectId: "tagset2018",
  storageBucket: "tagset2018.appspot.com",
  messagingSenderId: "689556051903"
};


// WEBPACK FOOTER //
// ./src/config.js